module.exports = __webpack_public_path__ + "static/media/prd-cat-md-4.48bd05ae.jpg";